import { render, staticRenderFns } from "./ShipmentDetailSummary.vue?vue&type=template&id=9f20734a"
import script from "./ShipmentDetailSummary.vue?vue&type=script&lang=js"
export * from "./ShipmentDetailSummary.vue?vue&type=script&lang=js"
import style0 from "./ShipmentDetailSummary.vue?vue&type=style&index=0&id=9f20734a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports